import React from 'react';
import styled, {css} from 'styled-components';
import {MuteControl} from './CustomControls/MuteControl';
import {PauseControl} from './CustomControls/PauseControl';
import {PlayControl} from './CustomControls/PlayControl';
import {UnmuteControl} from './CustomControls/UnmuteControl';

interface CustomControlsProps {
  disableMuteUnmuteControl?: boolean;
  disablePlayPauseControl?: boolean;
  handleMuteToggleClick: () => void;
  handlePlayToggleClick: () => void;
  muted: boolean;
  playing: boolean;
  videoHasAudio: boolean;
  customControlsPosition?: 'bottom' | 'top' | 'left-top';
  customControlsAlignment?: 'horizontal' | 'vertical';
}

export const CustomControls = ({
  disableMuteUnmuteControl = false,
  disablePlayPauseControl = false,
  handleMuteToggleClick,
  handlePlayToggleClick,
  muted,
  playing,
  videoHasAudio,
  customControlsPosition,
  customControlsAlignment,
  ref,
}: CustomControlsProps & {ref?: React.Ref<HTMLDivElement>}) => {
  return (
    <StyledCustomControls
      ref={ref}
      customControlsPosition={customControlsPosition}
      customControlsAlignment={customControlsAlignment}
    >
      {!disablePlayPauseControl && !playing && (
        <PlayControl playFunction={handlePlayToggleClick} />
      )}
      {!disablePlayPauseControl && playing && (
        <PauseControl pauseFunction={handlePlayToggleClick} />
      )}
      {!disableMuteUnmuteControl && videoHasAudio && !muted && (
        <MuteControl muteFunction={handleMuteToggleClick} />
      )}
      {!disableMuteUnmuteControl && videoHasAudio && muted && (
        <UnmuteControl unmuteFunction={handleMuteToggleClick} />
      )}
    </StyledCustomControls>
  );
};

const StyledCustomControls = styled.div<{
  customControlsPosition?: string;
  customControlsAlignment?: string;
}>`
  display: flex;
  position: absolute;
  right: 20px;
  gap: 10px;

  ${({customControlsAlignment}) => {
    if (customControlsAlignment === 'horizontal') {
      return css`
        flex-direction: row;
      `;
    }
    return css`
      flex-direction: column;
    `;
  }};

  ${({customControlsPosition}) => {
    if (customControlsPosition === 'left-top') {
      return css`
        right: auto;
        top: 20px;
        left: 20px;
      `;
    }
    if (customControlsPosition === 'top') {
      return css`
        top: 20px;
      `;
    }
    return css`
      bottom: 20px;
    `;
  }};
`;
